import { vocabApi } from '@/features/api';
import { buildVocabPayload } from '@/features/glossary';
import type { GlossaryRow } from '@/states/slices/glossaryEntriesSlice';

export const runSaveVocab = async (
  accessKey: string,
  token: string,
  entries: readonly GlossaryRow[],
): Promise<void> => {
  const vocab = buildVocabPayload(entries);
  if (Object.keys(vocab).length === 0) return;

  await vocabApi({ access_key: accessKey, token, vocab });
};

/**
 * 用語集を辞書保存 API に送信する（fail-open）。
 *
 * サーバ側の辞書は会話終了時に削除されるため、会話開始のたびに毎回送信する。
 * リトライはしない。失敗しても会話の開始は止めない。
 */
export const runSaveVocabFailOpen = async (
  accessKey: string,
  token: string,
  entries: readonly GlossaryRow[],
): Promise<void> => {
  try {
    await runSaveVocab(accessKey, token, entries);
  } catch (error) {
    // fail-open: 会話開始は止めないが、フロントから状況が分かるよう警告は出す。
    // error（AxiosError）には access_key/token を含むリクエストボディが入っているため、
    // そのまま出力せず message のみを出す。
    // eslint-disable-next-line no-console
    console.warn('vocab save failed', error instanceof Error ? error.message : error);
  }
};
